import { Button } from '@mui/material'

import useNavigate from 'utils/navigation/useCustomNavigate'
import './pageNotFound.scss'

const PageNotFound = () => {
  const { isInfluencerFlow, navigate } = useNavigate()

  return (
    <div className="page-not-found-container">
      <h1>404</h1>
      <h2>Page not found</h2>
      {isInfluencerFlow ? (
        <a
          href="https://www.heydayskincare.com/"
          className="app-btn app-btn-outlined"
        >
          Back to Home
        </a>
      ) : (
        <Button
          onClick={() => navigate('/')}
          className="app-btn app-btn-outlined"
        >
          Back to Home
        </Button>
      )}
    </div>
  )
}

export default PageNotFound
